import { render, staticRenderFns } from "./MultiChoiceCard.vue?vue&type=template&id=5d93f3d8&"
import script from "./MultiChoiceCard.vue?vue&type=script&lang=js&"
export * from "./MultiChoiceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports